export class BottomBarThemeMediaQuery {
    private mediaQueryList: MediaQueryList | undefined;
    private onChange: () => void;

    constructor(onChange: () => void) {
        this.onChange = onChange;
    }

    connect(): void {
        this.mediaQueryList = window.matchMedia(
            "(prefers-color-scheme: dark)"
        );

        if (
            typeof this.mediaQueryList.addEventListener === "function"
        ) {
            this.mediaQueryList.addEventListener(
                "change",
                this.onChange
            );
        } else if (
            typeof this.mediaQueryList.addListener === "function"
        ) {
            this.mediaQueryList.addListener(this.onChange);
        }
    }

    disconnect(): void {
        if (!this.mediaQueryList) {
            return;
        }

        if (
            typeof this.mediaQueryList.removeEventListener === "function"
        ) {
            this.mediaQueryList.removeEventListener(
                "change",
                this.onChange
            );
        } else if (
            typeof this.mediaQueryList.removeListener === "function"
        ) {
            this.mediaQueryList.removeListener(this.onChange);
        }

        this.mediaQueryList = undefined;
    }
}